exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main[data-v-02d9beb5] {\n  height: 500px;\n  width: 100%;\n  margin-top: 250px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-02d9beb5","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/root/workspace/platform-admin_Cbe5/src/style/theme.scss","/root/workspace/platform-admin_Cbe5/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/base/iframeLogin/index.vue
// module id = 889
// module chunks = 30